@app.service 'LocationService', ($q, $http, csConfig) ->

  @location = null

  @loadData = =>
    deferred = $q.defer()
    if @location?
      deferred.resolve(@location)
    else
      $http.get("#{csConfig.chefstepsEndpoint}/api/v0/locations.json").then(
        (response) =>
          @location = response.data
          deferred.resolve(@location)
        ,(error) ->
          deferred.reject(error)
      )
    deferred.promise

  # Location awareness methods
  @getCountry = =>
    @location?.country

  @isInUS = =>
    (@getCountry() == 'US' || @getCountry() == null)

  this
